import { makeStyles } from '@material-ui/core';

const titleStyles = makeStyles(theme => ({
  titleWrapper: {
    height: 'fit-content',
    borderRadius: 12,
    overflowWrap: 'break-word',
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column'
  },
  titleBar: {
    lineHeight: '28px',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1)
  },
  capitalize: {
    textTransform: 'capitalize'
  }
}));

export default titleStyles;
